

export interface ValidationResult {
  isValid: boolean;
  error?: string;
}


export function validateEmail(email: string): ValidationResult {
  const trimmed = email.trim();
  
  if (!trimmed) {
    return { isValid: false, error: 'E-mail é obrigatório' };
  }


  const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
  if (!emailRegex.test(trimmed)) {
    return { isValid: false, error: 'Por favor, insira um e-mail válido' };
  }


  const disposableDomains = [
    'tempmail.com',
    '10minutemail.com',
    'guerrillamail.com',
    'mailinator.com',
    'throwaway.email',
    'temp-mail.org',
  ];

  const domain = trimmed.split('@')[1]?.toLowerCase();
  if (domain && disposableDomains.includes(domain)) {
    return { isValid: false, error: 'E-mails descartáveis não são permitidos' };
  }

  return { isValid: true };
}


export function validatePassword(password: string): ValidationResult {
  if (!password) {
    return { isValid: false, error: 'Senha é obrigatória' };
  }

  if (password.length < 8) {
    return { isValid: false, error: 'Senha deve ter no mínimo 8 caracteres' };
  }

  if (password.length > 128) {
    return { isValid: false, error: 'Senha muito longa (máximo 128 caracteres)' };
  }


  if (!/[A-Z]/.test(password)) {
    return { isValid: false, error: 'Senha deve conter pelo menos uma letra maiúscula' };
  }


  if (!/[a-z]/.test(password)) {
    return { isValid: false, error: 'Senha deve conter pelo menos uma letra minúscula' };
  }


  if (!/[0-9]/.test(password)) {
    return { isValid: false, error: 'Senha deve conter pelo menos um número' };
  }






  return { isValid: true };
}


export function validateName(name: string): ValidationResult {
  const trimmed = name.trim();
  
  if (!trimmed) {
    return { isValid: false, error: 'Nome é obrigatório' };
  }

  if (trimmed.length < 3) {
    return { isValid: false, error: 'Nome deve ter no mínimo 3 caracteres' };
  }

  if (trimmed.length > 100) {
    return { isValid: false, error: 'Nome muito longo (máximo 100 caracteres)' };
  }


  const parts = trimmed.split(' ').filter(p => p.length > 0);
  if (parts.length < 2) {
    return { isValid: false, error: 'Por favor, insira nome e sobrenome' };
  }


  if (!/^[a-zA-ZÀ-ÿ\s'-]+$/.test(trimmed)) {
    return { isValid: false, error: 'Nome contém caracteres inválidos' };
  }

  return { isValid: true };
}


export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}


export function normalizeName(name: string): string {
  return name
    .trim()
    .split(' ')
    .filter(word => word.length > 0)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}


export function getPasswordStrength(password: string): {
  strength: 'fraca' | 'média' | 'forte' | 'muito-forte';
  score: number;
} {
  let score = 0;


  if (password.length >= 8) score += 20;
  if (password.length >= 12) score += 10;
  if (password.length >= 16) score += 10;


  if (/[a-z]/.test(password)) score += 15;
  if (/[A-Z]/.test(password)) score += 15;
  if (/[0-9]/.test(password)) score += 15;
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score += 15;


  const commonPatterns = ['123', 'abc', 'qwerty', 'password', 'senha'];
  const hasCommonPattern = commonPatterns.some(pattern => 
    password.toLowerCase().includes(pattern)
  );
  if (!hasCommonPattern) score += 10;


  let strength: 'fraca' | 'média' | 'forte' | 'muito-forte';
  if (score < 40) strength = 'fraca';
  else if (score < 60) strength = 'média';
  else if (score < 80) strength = 'forte';
  else strength = 'muito-forte';

  return { strength, score };
}
